import React from "react";
import { ImageIcon, BarChart3 } from "lucide-react";

// A swappable media frame. Pass `src` to show the real asset; leave it null to
// render an on-brand "coming soon" placeholder in the right aspect ratio.
export default function MediaPlaceholder({ src, label, caption, aspect = "aspect-[4/3]", kind = "figure", testid }) {
  const Icon = kind === "graph" ? BarChart3 : ImageIcon;
  return (
    <figure className="w-full" data-testid={testid}>
      <div className={`relative w-full ${aspect} rounded-2xl overflow-hidden border border-line`}>
        {src ? (
          <img src={src} alt={label || ""} className="w-full h-full object-contain bg-cream" loading="lazy" />
        ) : (
          <div className="w-full h-full border-2 border-dashed border-line bg-white flex flex-col items-center justify-center text-center px-6">
            <div className="w-12 h-12 rounded-xl bg-purple/10 flex items-center justify-center mb-3">
              <Icon className="w-6 h-6 text-purple-mid" strokeWidth={1.6} />
            </div>
            {label && <p className="font-heading text-purple text-lg leading-tight">{label}</p>}
            <span className="mt-2 text-[10px] uppercase tracking-[0.2em] text-gold-dark font-bold bg-gold/10 rounded-full px-3 py-1">Coming soon</span>
          </div>
        )}
      </div>
      {caption && <figcaption className="mt-3 text-[13px] text-lav leading-snug">{caption}</figcaption>}
    </figure>
  );
}
